var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var MedicalCenterConfig = /** @class */ (function (_super) {
    __extends(MedicalCenterConfig, _super);
    function MedicalCenterConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MedicalCenterConfig.prototype.getTop = function () {
        return Number(this.top);
    };
    MedicalCenterConfig.prototype.setTop = function (top) {
        this.top = top;
    };
    MedicalCenterConfig.prototype.getBottom = function () {
        return Number(this.bottom);
    };
    MedicalCenterConfig.prototype.setBottom = function (bottom) {
        this.bottom = bottom;
    };
    MedicalCenterConfig.prototype.getRight = function () {
        return Number(this.right);
    };
    MedicalCenterConfig.prototype.setRight = function (right) {
        this.right = right;
    };
    MedicalCenterConfig.prototype.getLeft = function () {
        return Number(this.left);
    };
    MedicalCenterConfig.prototype.setLeft = function (left) {
        this.left = left;
    };
    MedicalCenterConfig.prototype.getMedicineNameFontSize = function () {
        var fontSize = Number(this.medicine_name_font_size);
        return Number.isFinite(fontSize) && fontSize > 0 ? fontSize : 40;
    };
    MedicalCenterConfig.prototype.setMedicineNameFontSize = function (medicine_name_font_size) {
        this.medicine_name_font_size = medicine_name_font_size;
    };
    MedicalCenterConfig.prototype.getMedicineDescriptionFontSize = function () {
        var fontSize = Number(this.medicine_description_font_size);
        return Number.isFinite(fontSize) && fontSize > 0 ? fontSize : 25;
    };
    MedicalCenterConfig.prototype.setMedicineDescriptionFontSize = function (medicine_description_font_size) {
        this.medicine_description_font_size = medicine_description_font_size;
    };
    MedicalCenterConfig.prototype.isPatientJourneysEnabled = function () {
        return this.patient_journeys_enabled === true;
    };
    MedicalCenterConfig.prototype.setPatientJourneysEnabled = function (enabled) {
        this.patient_journeys_enabled = enabled;
    };
    return MedicalCenterConfig;
}(Model));
export default MedicalCenterConfig;
